import { postMessageToMain, PWMessageType } from "../../physx/PhysXWorker";
import { RobotPhysXActor } from "../RobotPhysXActor";

export class RTPhysXSensor {
  public isOn: boolean = false;
  constructor(public actor: RobotPhysXActor) { }
  
  public friendlyName(): string { 
    return 'Base Sensor';
  }

  public getId(): string {
    return 'BaseSensor';
  }

  public async activate() {
    this.isOn = true;
    // this.actor.emit(ActorEvents.SensorChange, this);
  }

  public async deactivate() {
    this.isOn = false;
    // this.actor.emit(ActorEvents.SensorChange, this);
  }

  public sendUIData(messageTypeId: string, data: any) {
    const handlerPath = `${this.actor.object._id}/${messageTypeId}`;
    postMessageToMain({ type: PWMessageType.DATA_UPDATE, path: handlerPath, data });
  }

  public render(delta: number): void {}
}

export abstract class RTPhysXSimSensor extends RTPhysXSensor {
  public lastUpdate = 0;
  public render(delta: number): void {
    if (this.actor.scene.lastUpdate > this.lastUpdate) {
      this.lastUpdate = this.actor.scene.lastUpdate;
      this.collectAndSendData(delta);
    }
  }
  protected abstract collectAndSendData(delta: number):void;
}